import { http } from "@/core/api/";

const dashboardUrl = "api/dashboard";
export default {
  async getDashbord(id, params) {
    return http.get(`${dashboardUrl}/${id}/embeddata`, {
      params
    });
  }
};
